<script lang="ts">
	import { type MailTemplateEntry } from './MailTemplateConfig.model'
	import SecondaryButton, { SecondaryBtnColors } from '../../atoms/SecondaryButton.svelte'
	import { ButtonIcons } from '../../types/enums'
	import Skeleton from 'svelte-skeleton/Skeleton.svelte'

	export let entry: MailTemplateEntry
	export let loadingMode: boolean = false
	export let headerMode: boolean = false
	export let onDelete: (id: string) => void = (id: string) => {}
	export let onEdit: (entry: MailTemplateEntry) => void = (entry: MailTemplateEntry) => {}

	let { id, mailName, mailTemplateId, daysUntilDeletion } = entry || {}
</script>

<div class="mail-template-entry" class:headerMode>
	<div class="mail-template-entry__body">
		{#if loadingMode}
			<div class="mail-template-entry__body--entry">
				<Skeleton height="0.75rem" width="5rem" />
				<Skeleton height="0.75rem" width="7.5rem" />
			</div>
			<div class="mail-template-entry__body--entry">
				<Skeleton height="0.75rem" width="5rem" />
				<Skeleton height="0.75rem" width="7.5rem" />
			</div>
		{:else if headerMode}
			<div class="mail-template-entry__body--entry">
				<h3>Mailname</h3>
			</div>
			<div class="mail-template-entry__body--entry">
				<h3>Templatename</h3>
			</div>
			<div class="mail-template-entry__body--entry">
				<h3>Aufbewahrungsfrist</h3>
			</div>
		{:else}
			<div class="mail-template-entry__body--entry">
				<span>{mailName}</span>
			</div>
			<div class="mail-template-entry__body--entry">
				<span>{mailTemplateId}</span>
			</div>
			<div class="mail-template-entry__body--entry">
				<span>{daysUntilDeletion} {daysUntilDeletion > 1 ? 'Tage' : 'Tag'}</span>
			</div>
		{/if}
	</div>
	<div class="mail-template-entry__footer">
		{#if loadingMode}
			<Skeleton height="2rem" width="2.25rem" />
			<Skeleton height="2rem" width="2.25rem" />
		{:else if headerMode}
			<div style="width: 2.25rem"></div>
			<div style="width: 2.25rem"></div>
		{:else}
			<SecondaryButton
				leftIcon={ButtonIcons.TRASH}
				color={SecondaryBtnColors.RED}
				displayIconOnly
				on:click={() => onDelete(entry.id)}
			/>
			<SecondaryButton leftIcon={ButtonIcons.EDIT} displayIconOnly on:click={() => onEdit(entry)} />
		{/if}
	</div>
</div>

<style lang="scss">
	@use '$styles/global';

	.mail-template-entry {
		background: white;
		border: 1px solid #ddd;
		border-radius: 0.125rem;
		box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
		padding: 0.75rem;
		transition: transform 0.3s ease-out;
		min-width: 175px;

		@include global.flex-row(1rem, $justify: space-between);

		width: 100%;

		&:hover {
			transform: translateY(-5px) scale(1.001) translateZ(0);
		}

		&.headerMode:hover {
			transform: unset;
		}
	}

	.mail-template-entry__body {
		@include global.flex-row(0.5rem);

		width: 100%;
	}

	.mail-template-entry__body--entry {
		@include global.flex-col(0.25rem, $alignment: flex-start);

		width: 100%;

		& h3,
		span {
			margin: 0;
		}
	}

	.mail-template-entry__footer {
		@include global.flex-row(0.75rem, $justify: space-between);
	}

	button {
		display: flex;
		align-items: center;
		gap: 0.25rem;
		border: none;
		border-radius: 0.5rem;
		padding: 0.4rem 0.75rem;
		cursor: pointer;
		font-size: 0.9rem;
		transition: background 0.2s;
	}

	button.edit {
		background: #3b82f6;
		color: white;
	}

	button.edit:hover {
		background: #2563eb;
	}

	button.delete {
		background: #ef4444;
		color: white;
	}

	button.delete:hover {
		background: #dc2626;
	}

	button.save {
		background: #10b981;
		color: white;
	}

	button.save:hover {
		background: #059669;
	}

	button.cancel {
		background: #e5e7eb;
		color: #374151;
	}

	button.cancel:hover {
		background: #d1d5db;
	}
</style>
